import { Navigate, useNavigate } from 'react-router-dom';

import { EmptyCard, PageHeader } from '@/components/PageHeader';
import { useSafeAccess } from '@/lib/access';
import { useSites } from '@/lib/queries';

import { sitePath } from './siteMenu';

/** 내 현장 — 안전 권한 없이 배정 현장만 보는 사람의 첫 화면(DOC-136 §6). 현장이 하나면 곧장 그 현장 홈으로. */
export function MySitesPage() {
  const navigate = useNavigate();
  const access = useSafeAccess();
  const sites = useSites();
  const mine = (sites.data ?? []).filter((site) => access.siteIds.includes(site.id));

  if (access.all) return <Navigate to="/dashboard" replace />;
  if (access.siteIds.length === 1) return <Navigate to={sitePath(access.siteIds[0]!)} replace />;

  return (
    <div className="space-y-5">
      <PageHeader title="내 현장" />
      {mine.length === 0 ? (
        <EmptyCard>배정된 현장이 없습니다.</EmptyCard>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
          {mine.map((site) => (
            <button
              key={site.id}
              type="button"
              className="card flex items-center justify-between p-5 text-left text-ui-md font-semibold hover:shadow-md"
              onClick={() => navigate(sitePath(site.id))}
            >
              {site.name}
              <span style={{ color: 'var(--accent)' }} aria-hidden>
                →
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
